import { getProjectCredits } from '@/requests/monetization/getProjectCredits';
import { subscriptionToolId } from '@/consts/configs';
import { checkCredits } from './checkCredits';
import { isAuthorized } from './isAuthorized';
import { openOfferScreen } from './openOfferScreen';
import { openRegistrationModal } from './openRegistrationModal';
import { isProUser } from './isProUser';

type GenerationPipelineResult = {
  canProcess?: boolean;
  projectCreditsCount?: number | null;
};

type GenerationPipelineParams = {
  webhookId: string;
};

const isNumber = (value: unknown): value is number =>
  typeof value === 'number' && !Number.isNaN(value);

const generationPipeline = async ({
  webhookId,
}: GenerationPipelineParams): Promise<GenerationPipelineResult> => {
  // Check authorization
  if (!isAuthorized()) {
    openRegistrationModal();
    return { canProcess: false };
  }

  // Check monetization
  const projectCreditsCount = await getProjectCredits({ webhookId });

  if (!isNumber(projectCreditsCount)) return { canProcess: false };

  const { isCreditsEnough } = await checkCredits({ projectCreditsCount });

  if (!isCreditsEnough) {
    const hasProSubscription = await isProUser();

    if (!hasProSubscription) {
      openOfferScreen();
      return { canProcess: false };
    }
    // Offer subscription upsell when pro credits are insufficient
    openOfferScreen(subscriptionToolId);
    return { canProcess: false };
  }

  // When all checks passed return true
  return { canProcess: true, projectCreditsCount };
};

export { generationPipeline };
